<template>
<div class="cennert_bg">
    <div class="index_cennert">
      <h2>国内领先的元宇宙 <span>|</span> 云上展览服务提供商</h2>
      <div class="desc">强大的专业团队，提供全方位、多行业的的整合解决方案</div>
      <div class="cennert">
        <ul class="connert_left">
          <li 
            v-for="(item,index) in data" :key="index"
            @mouseover="mouseOver(index)"
            >
            <h4 :class="{Left_tip:img==index}">{{item.text}}</h4>
          </li>
        </ul>
        <div class="connert_right">
            <div class="connert_right_top">
                <div class="right_top_pop1" @click="changeName(data[img].link_[0])" v-if="data[img].imag[0]">
                     <img alt="" :src="data[img].imag[0]"/>
                    <div class="box_txt">
                        <p>{{data[img].text_h2[0]}}</p>
                    </div>
                </div>
                <div class="right_top_pop2"  @click="changeName(data[img].link_[1])" v-if="data[img].imag[1]">
                      <img alt="" :src="data[img].imag[1]"/>
                    <div class="box_txt">
                            <p>{{data[img].text_h2[1]}}</p>
                    </div>
                </div>
            </div>
            <div class="connert_right_bottom">
                <ul class="bottom_list">
                    <li @click="changeName(data[img].link_[2])" v-if="data[img].imag[2]">
                        <img alt="云创展汇" :src="data[img].imag[2]"/>
                         <div class="box_txt">
                               <p>{{data[img].text_h2[2]}}</p>
                          </div>
                    </li>
                    <li @click="changeName(data[img].link_[3])" v-if="data[img].imag[3]">
                        <img alt="云创展汇" :src="data[img].imag[3]"/>
                         <div class="box_txt">
                               <p>{{data[img].text_h2[3]}}</p>
                         </div>
                    </li>
                    <li @click="changeName(data[img].link_[4])" v-if="data[img].imag[4]">
                        <img  alt="云创展汇" :src="data[img].imag[4]"/>
                         <div class="box_txt">
                               <p>{{data[img].text_h2[4]}}</p>
                         </div>
                    </li>
                </ul>
            </div>
        </div>
        </div>
      </div>
      <div class="application">
          <h2>行业应用</h2>
          <div class="desc">场景营销体验必备，展示更多可能</div>
      </div>
  </div>
</template>
<script>
export default {
    data() {
        return {
            aa:"gif",
            data:[
                {
                    text:"线上云展会",
                    imag:['','','','',''],
                    text_h2:["","","","",""],
                    link_:[
                            {
                                Model_link:1,
                                codeid:"",
                                bs:1
                            },
                            {
                                Model_link:1,
                                codeid:"",
                                bs:1
                            },
                            {
                                Model_link:1,
                                codeid:"",
                                bs:1
                            },
                            {
                                Model_link:1,
                                codeid:"",
                                bs:1
                            },
                            {
                                Model_link:1,
                                codeid:"",
                                bs:1
                            },
                        ]
                },
                {
                    text:"3D产品建模",
                    imag:['','','','',''],
                    text_h2:["","","",'',''],
                    link_:[     
                        {
                                Model_link:'',
                                codeid:112,
                                bs:1
                            },
                            {
                                Model_link:'',
                                codeid:113,
                                bs:1
                            },
                            {
                                Model_link:'',
                                codeid:114,
                                bs:1
                            },
                            {
                                Model_link:'',
                                codeid:115,
                                bs:1
                            },
                            {
                                Model_link:'',
                                codeid:116,
                                bs:1
                            },
                        ]
                },

                 {
                    text:"VR实拍复刻",
                    imag:['','','','',''],
                    text_h2:["","","",'',''],
                    link_:[     
                        {
                                Model_link:'',
                                codeid:112,
                                bs:1
                            },
                            {
                                Model_link:'',
                                codeid:113,
                                bs:1
                            },
                            {
                                Model_link:'',
                                codeid:114,
                                bs:1
                            },
                            {
                                Model_link:'',
                                codeid:115,
                                bs:1
                            },
                            {
                                Model_link:'',
                                codeid:116,
                                bs:1
                            },
                        ]
                },
               
                {
                  text:"元宇宙3D展厅",
                  imag:['','','','',''],
                  text_h2:["","","",'',''],
                  link_:[     
                  {
                          Model_link:'',
                          codeid:112,
                          bs:1
                      },
                      {
                          Model_link:'',
                          codeid:113,
                          bs:1
                      },
                      {
                          Model_link:'',
                          codeid:114,
                          bs:1
                      },
                      {
                          Model_link:'',
                          codeid:115,
                          bs:1
                      },
                      {
                          Model_link:'',
                          codeid:116,
                          bs:1
                      },
                  ]
                },
                {
                     text:"党建文博展馆",
                    imag:['','','','',''],
                    text_h2:["","","",'',''],
                    link_:[     
                        {
                                Model_link:'',
                                codeid:112,
                                bs:1,
                                linkcmd:"",
                            },
                            {
                                Model_link:'',
                                codeid:113,
                                bs:1,
                                linkcmd:"",
                            },
                            {
                                Model_link:'',
                                codeid:114,
                                bs:1,
                                linkcmd:"",
                            },
                            {
                                Model_link:'',
                                codeid:115,
                                bs:1,
                                linkcmd:"",
                            },
                            {
                                Model_link:'',
                                codeid:116,
                                bs:1,
                                linkcmd:"",
                            },
                        ]
                },
                {
                    text:"地产房产宣传",
                    imag:['','','','',''],
                    text_h2:["","","",'',''],
                    link_:[     
                            {
                                Model_link:'',
                                codeid:"",
                                linkcmd:"",
                                bs:1
                              
                            },
                            {
                                Model_link:'',
                                codeid:"",
                                linkcmd:"",
                                bs:1
                            },
                            {
                                Model_link:'',
                                codeid:"",
                                linkcmd:"",
                                bs:1
                            },
                            {
                                Model_link:'',
                                codeid:"",
                                linkcmd:"",
                                bs:1
                            },
                            {
                                Model_link:'',
                                codeid:"",
                                linkcmd:"",
                                bs:1
                            },
                        ]
                },
                 {
                    text:"元宇宙3D画展",
                    imag:['','','','',''],
                    text_h2:["","","",'',''],
                    link_:[     
                        {
                                Model_link:'',
                                codeid:112,
                                bs:1
                            },
                            {
                                Model_link:'',
                                codeid:113,
                                bs:1
                            },
                            {
                                Model_link:'',
                                codeid:114,
                                bs:1
                            },
                            {
                                Model_link:'',
                                codeid:115,
                                bs:1
                            },
                            {
                                Model_link:'',
                                codeid:116,
                                bs:1
                            },
                        ]
                },
            ],
            img:1
        }
    },
    computed:{
        jsx_data(){
            return this.data
        }
    },
    methods:{
        mouseOver(index){
            this.img = index
        },
        // 将我的数据传给父组件再由父组件传参给弹窗也就是index.vue
        changeName(link_){
            if(link_.codeid == '' ){
                return false
            }else{
               
                if(link_.bs==1){
                    if(link_.linkcmd == null ||link_.linkcmd == ''){
                        return false
                    }else{
                        this.$emit('handleChange', link_) // 触发父组件中handleChange事件并传参Jack
                    }
                }else{
                    this.$emit('handleChange', link_) // 触发父组件中handleChange事件并传参Jack
                }   
               
            }
        },
        // 请求数据
        indexdata(){
            // this.link_
           this.$axios.post(
                        "https://www.3dyunchuang.com/api/test/GetCateInfo2",
                        this.$qs.stringify({
                            type:"index",
                            cate:1,
                            page:1,           
                        }),    
                        )
                        .then(res => {
                        this.img = 0
                            for(var i=0;i<res.data.data.length;i++){
                                    this.data[0].imag[i]  = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[i].img+'.'+res.data.data[i].type
                                    this.data[0].text_h2[i] = res.data.data[i].title
                                    this.data[0].link_[i].codeid = res.data.data[i].ID
                                    this.data[0].link_[i].linkcmd = res.data.data[i].link
                                    this.data[0].link_[i].Model_link = res.data.data[i].cate
                            }
                        })
                            .catch(error => {                        
            });
            this.$axios.post(
                        "https://www.3dyunchuang.com/api/test/GetCateInfo2",
                        this.$qs.stringify({
                            type:"index",
                            cate:4,
                            page:0,           
                        }),    
                        )
                        .then(res => {
                            for(var i=0;i<res.data.data.length;i++){
                                    this.data[1].imag[i]  = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[i].img+'.'+res.data.data[i].type
                                    this.data[1].text_h2[i] = res.data.data[i].title
                                    this.data[1].link_[i].codeid = res.data.data[i].ID
                                    this.data[1].link_[i].linkcmd = res.data.data[i].link
                                    this.data[1].link_[i].Model_link = res.data.data[i].cate
                            }
                        })
                        .catch(error => {
            });
            this.$axios.post(
                        "https://www.3dyunchuang.com/api/test/GetCateInfo2",
                        this.$qs.stringify({
                            type:"index",
                            cate:19,
                            page:0,           
                        }),    
                        )
                        .then(res => {
                          for(var i=0;i<res.data.data.length;i++){
                                this.data[2].imag[i]  = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[i].img+'.'+res.data.data[i].type
                                this.data[2].text_h2[i] = res.data.data[i].title
                                this.data[2].link_[i].codeid = res.data.data[i].ID
                                this.data[2].link_[i].linkcmd = res.data.data[i].link
                                this.data[2].link_[i].Model_link = res.data.data[i].cate
                            }
                        })
                        .catch(error => {
            });


            this.$axios.post(
                        "https://www.3dyunchuang.com/api/test/GetCateInfo2",
                        this.$qs.stringify({
                            type:"index",
                            cate:18,
                            page:0,           
                        }),    
                        )
                        .then(res => {
                          for(var i=0;i<res.data.data.length;i++){
                                this.data[3].imag[i]  = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[i].img+'.'+res.data.data[i].type
                                this.data[3].text_h2[i] = res.data.data[i].title
                                this.data[3].link_[i].codeid = res.data.data[i].ID
                                this.data[3].link_[i].linkcmd = res.data.data[i].link
                                this.data[3].link_[i].Model_link = res.data.data[i].cate
                            }
                        })
                        .catch(error => {
            });



            this.$axios.post(
                  "https://www.3dyunchuang.com/api/test/GetCateInfo2",
                  this.$qs.stringify({
                       type:"index",
                      cate:9,
                      page:0,           
                  }),    
                  )
                  .then(res => {
   
                    for(var i=0;i<res.data.data.length;i++){
                          this.data[4].imag[i]  = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[i].img+'.'+res.data.data[i].type
                          this.data[4].text_h2[i] = res.data.data[i].title
                          this.data[4].link_[i].codeid = res.data.data[i].ID
                          this.data[4].link_[i].linkcmd = res.data.data[i].link
                          this.data[4].link_[i].Model_link = res.data.data[i].cate
                      }
                  })
                  .catch(error => {
            });
            this.$axios.post(
                            "https://www.3dyunchuang.com/api/test/GetCateInfo2",
                            this.$qs.stringify({
                                 type:"index",
                                cate:2,
                                page:0         
                            }),    
                            )
                            .then(res => {
                            for(var i=0;i<res.data.data.length;i++){
                                this.data[5].imag[i]  = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[i].img+'.'+res.data.data[i].type
                                this.data[5].text_h2[i] = res.data.data[i].title
                                this.data[5].link_[i].codeid = res.data.data[i].ID
                                this.data[5].link_[i].linkcmd = res.data.data[i].link
                                this.data[5].link_[i].Model_link = res.data.data[i].cate
                            }
            })  

            this.$axios.post(
                        "https://www.3dyunchuang.com/api/test/GetCateInfo2",
                        this.$qs.stringify({
                             type:"index",
                            cate:22,
                            page:0,           
                        }),    
                        )
                        .then(res => {
                             for(var i=0;i<res.data.data.length;i++){
                                this.data[6].imag[i]  = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[i].img+'.'+res.data.data[i].type
                                this.data[6].text_h2[i] = res.data.data[i].title
                                this.data[6].link_[i].codeid = res.data.data[i].ID
                                this.data[6].link_[i].linkcmd = res.data.data[i].link
                                this.data[6].link_[i].Model_link = res.data.data[i].cate
                            }
                        })
                        .catch(error => {
            });
   
        }
    },
    mounted(){
        this.indexdata()
        // 请求数据       
    },
}
</script>
<style scoped>
ul,li{
    list-style: none;
}
.cennert_bg{
    width: 100%;
    height: 920px;
    background: #f2f6f9;
}
.index_cennert{
    width: 1202px;
    margin: 0 auto;
}
.index_cennert h2{
  height: 36px;
  line-height: 34px;
    padding-top: 63px;
    text-align: center;
    color: #222;
    font-weight: 400;
    font-size: 34px;
    font-weight: bold;
       vertical-align:middle
}
.index_cennert h2 span{
    font-size: 34px;
    transform: scale(0.8);
    font-weight: normal;
 
}
.desc{
    padding-top: 12px;
    padding-bottom: 60px;
    font-size: 18px;
    color: #666666;
    text-align: center
}
.connert_left{
    float: left;
    height: 574px;
    background-color: #2e353e;
    background: #1a2e56;
}
.connert_left li{
    line-height: 75px;
    color: #fff;
    width: 148px;
    height: 75px;
    text-align: center;
    font-size: 14px;
    position: relative; 
}
.connert_left li:last-of-type:after{
    height: 0;
}
.connert_left li:after {
    content: "\0020";
    display: block;
    height: 1px;
    background: #334569;
    overflow: hidden;
    width: 24px;
    margin: 0 auto;
    transition: 0.5s all;
}
.connert_left li h4{
    font-weight: normal;
}

.connert_right{
    width: 1031px;
    float: right;
    height: 574px;
}
.detailed_footer h4{
    font-size: 16px;
    margin-top: 36px;
    color: #989a99;
    font-weight: normal;
}
.connert_right_top{
    width: 100%;
    height: 333px;
    margin-bottom: 20px;
}
.connert_right_bottom{
    width: 100%;
    height: 220px;
}
.right_top_pop1{
    width: 504px;
    height: 100%;
    float: left;
    position: relative;
    overflow: hidden;
}
.right_top_pop2{
    width: 504px;
    height: 100%;
    float: right;
    position: relative;
    overflow: hidden;
}
.bottom_list{
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content:space-between
}
.bottom_list li{
    width: 327px;
    height: 100%;
    position: relative;
    overflow: hidden;
}
.box_txt{
    position: absolute;
    bottom: 0px;
    left: 0px;    
    height: 42px;
    width: 100%;
    background: rgba(25,25,25,.5);
    line-height: 42px;
    color: #fff;
}
.box_txt p{
    margin-left: 20px;
    font-size: 14px;
}
.right_top_pop1 img{
    width: 100%;
    height: 100%;
}
.Left_tip{
    position: absolute;
    left: -12px;
    top: 0;
    width: 191px;
    height: 68px;
    background: url("../../assets/imges/hy_lef.png") no-repeat  !important;
    background-size:100% 100%;
    cursor: pointer;
    font-weight: bold!important;
    transition: 0.5s all;
    z-index: 9;
}
.connert_right img{
    width: 100%;
    height: 100%;
    transition: 1s all;
    cursor: pointer;
}
.connert_right img:hover{
    transform: scale(1.2);
}
.mobile_terminal{
    width: 100%;
    height: 170px;
    -webkit-box-shadow: 0px 2px 0 rgba(0,0,0,.1);
    border-radius: 0 0 2px 2px;
    display: none;
}
.mobile_terminal ul{
    width: 100%;
    height: 100%;
    display: flex;
}
.mobile_terminal ul li{
    flex: 1;
    height: 184px;
    text-align: center;
}
.mobile_terminal ul li div{
    width: 100%;
    text-align: center;
    height: 50px;
    margin-bottom: 10px;
}
.mobile_terminal ul li div img{
    width: 50px;
    height: 50px;
}
.mobile_terminal ul li p{
    color: #333;
    font-size: .22rem;
    font-weight: 500;
    margin-bottom: .16rem;
}
.mobile_terminal ul li span{
    color: #333;
    font-size: .22rem;
    font-weight: 500;
    margin-bottom: .16rem;
}
.application{
    width: 100%;
    height: 100px;
    display: none;
}
.products{
    width: 100%;
    height: 230px;
    display: none;
}

</style>





// WEBPACK FOOTER //
// src/common/index/page-cennert.vue